/* ==========================================================================
   add-to-cart.js — bouton « Ajouté ✓ » reflétant le PANIER (léger + réactif)
   --------------------------------------------------------------------------
   Pose .fm-added sur un bouton quand le VARIANT SÉLECTIONNÉ est dans le panier.
   - Ajout : affichage OPTIMISTE (instantané au clic) + période de grâce pour
     éviter le clignotement le temps que le serveur confirme.
   - Changement de variante : instantané (panier en cache).
   - Ajout / suppression / quantité : détecté via l'événement thème
     `shopify:cart:lines-update` + un filet de sécurité (vérif légère toutes les
     1,5 s, uniquement quand l'onglet est visible).
   - Le panier est lu SANS CACHE (sinon suppression = mise à jour très lente).
   À charger : <script src="{{ 'add-to-cart.js' | asset_url }}" defer></script>
   ========================================================================== */
(function () {
  var CART = new Set();
  var pending = Object.create(null); // variantId -> expiration (ms) d'un ajout optimiste
  var lastKey = null;
  var busy = false, again = false;

  function pendingActive(v) {
    return !!pending[v] && pending[v] > Date.now();
  }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    // ?_=... + no-store : lecture FRAÎCHE du panier (pas de cache navigateur)
    fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ids = (c.items || []).map(function (i) { return String(i.variant_id); });
        CART = new Set(ids);
        // nettoie les ajouts optimistes confirmés (ou expirés)
        for (var k in pending) { if (CART.has(k) || pending[k] <= Date.now()) delete pending[k]; }
        var key = ids.slice().sort().join(',') + '|' + Object.keys(pending).sort().join(',');
        if (key !== lastKey) { lastKey = key; updateAll(); }
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }

  function currentVariantId(btn) {
    var f = btn.closest('form') || document;
    var input = f.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var m = (location.search || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function updateBtn(btn) {
    var v = currentVariantId(btn);
    if (v && (CART.has(v) || pendingActive(v))) btn.classList.add('fm-added');
    else btn.classList.remove('fm-added');
  }
  function updateAll() {
    document.querySelectorAll('.add-to-cart-button').forEach(updateBtn);
  }

  function enabled(b) {
    return b && !b.disabled && !b.hasAttribute('disabled') && b.getAttribute('aria-disabled') !== 'true';
  }

  /* Clics : ajout optimiste (instantané, avec période de grâce) + changement de variante */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest && e.target.closest('.add-to-cart-button');
    if (addBtn && enabled(addBtn)) {
      var v = currentVariantId(addBtn);
      if (v) { pending[v] = Date.now() + 5000; lastKey = null; addBtn.classList.add('fm-added'); }
    } else if (e.target.closest && e.target.closest('.variant-option, label, .swatch, [data-option-value-id], swatch-input')) {
      setTimeout(updateAll, 60);
    }
  }, true);
  document.addEventListener('change', function () { setTimeout(updateAll, 40); }, true);

  /* Panier modifié -> rafraîchissement immédiat */
  ['shopify:cart:lines-update', 'cart:updated', 'cart:refresh', 'theme:cartchanged', 'theme:cart:reload'].forEach(function (ev) {
    document.addEventListener(ev, refresh, true);
    window.addEventListener(ev, refresh, true);
  });

  /* Filet de sécurité : vérif légère toutes les 1,5 s (onglet visible). lastKey
     évite tout re-render inutile tant que le panier ne change pas. */
  setInterval(function () { if (!document.hidden) refresh(); }, 1500);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);

  refresh(); // au chargement
})();